import enhance from './enhancer';
import MyWatchlist from './MyWatchlist.js';

export default enhance(MyWatchlist);
